import React from "react";
import { Users, Clock, Stethoscope } from "lucide-react";
import StatCard from "../../../components/private/waitingRoom/StatCard";

const WaitingRoomStats = ({ stats, avgWaitingTime, darkMode, Text, textTranslator }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
      <StatCard
        label={<Text>currentlyWaiting</Text>}
        value={stats.waiting}
        icon={<Users size={24} />}
        color={darkMode ? "bg-slate-800" : "bg-white"}
      />
      <StatCard
        label={<Text>withDoctor</Text>}
        value={stats.inProgress}
        icon={<Stethoscope size={24} />}
        color={darkMode ? "bg-slate-800" : "bg-white"}
        trend={textTranslator("+2 since last hour", "WAITING_ROOM")}
      />
      <StatCard
        label={<Text>avgWaitTime</Text>}
        value={avgWaitingTime}
        icon={<Clock size={24} />}
        color={darkMode ? "bg-slate-800" : "bg-white"}
        trend={
          stats.avgWait > 45
            ? textTranslator("Heavy Load", "WAITING_ROOM")
            : textTranslator("Normal Load", "WAITING_ROOM")
        }
      />
    </div>
  );
};

export default WaitingRoomStats;
